import axios from 'axios'
import {asResponse} from '../util'

export const ACTIVITY_SWR_KEY = ({activityId}) => [`/bff/activities/${activityId}?load=user,service,version,contract,environment,resource,response&limit=500`, activityId]

export const getActivity = async (url, activityId) => {
  if (!activityId) {
    return {
      activity: undefined
    }
  }
  const resp = await asResponse(axios.get(url.replace('${activityId}', activityId)))
  const activity = resp.data
  return {
    activity
  }
}

export const ACTIVITIES_SWR_KEY = ({
                                     serviceId,
                                     versionId,
                                     environmentId,
                                     resourceId,
                                     responseId
                                   }) => [`/bff/activities?service=${serviceId}&version=${versionId}&environment=${environmentId}&resource=${resourceId}&response=${responseId}&load=user,service&limit=1000&sort={"createdAt": -1}`, serviceId, versionId, environmentId, resourceId, responseId]

export const getActivities = async (url) => {
  const resp = await asResponse(axios.get(url))
  const activities = resp.data ? (resp.data.results || []) : []
  return {activities}
}
